








import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';

const OverlayProps = Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class Overlay extends OverlayProps {
  @Watch('visible')
  public onVisibleChanged(visible: boolean) {
    if (document && document.documentElement) {
      if (visible) {
        document.documentElement.classList.add('modal-open');
      } else {
        document.documentElement.classList.remove('modal-open');
      }
    }
  }
}
